import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading } from "../components/Common";

export default function StaffDirectory() {
  const [staff, setStaff] = useState(null);
  useEffect(() => { api.staff().then(({ data }) => setStaff(data)); }, []);
  if (staff === null) return <Loading />;
  return (
    <div data-testid="staff-directory-page">
      <PageHeader kicker="Directory" title="Staff Directory" subtitle="All faculty and staff — searchable directory." />
      <Section>
        <DataTable
          columns={[
            { key: "name", label: "Name", render: (r) => `${r.first_name} ${r.last_name}` },
            { key: "role", label: "Role" },
            { key: "department", label: "Department" },
            { key: "subjects", label: "Subjects", render: (r) => (r.subjects || []).join(", ") },
            { key: "email", label: "Email" },
          ]}
          rows={staff}
        />
      </Section>
    </div>
  );
}
